












































import {
  Component, Prop, mixins, Watch,
} from '@samclick-commons';
import { AuthorizationStore, MyaaffiliateStore, Payload } from '@samclick-store-factory';
import SamclickMixins from '@/utils/mixins';

class FormData {
  email: string = ''

  activeSteps: number = 1
}
class PasswordResetState {
    public formData: FormData = new FormData()
}

@Component({
  /**
     * Imported components
     * */
  components: {},
  /**
     * Stores values
     * */
  computed: {},
  /**
     * Component properties
     * */
  props: {},
})
export default class PasswordReset extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
  state = new PasswordResetState();

    rules = {}

  /**
   * Watchers
   * */
  @Watch('ifLocaleChange', { immediate: true })
    langChangea(val: string) {
      this.rules = {
        email: [
          { required: true, message: this.$t('change_password.err_email'), trigger: 'blur' },
        ],
      };
    }

  /**
   * Methods
   * */
  resetPassword() {
    this.$refs.passwordForm.validate((valid) => {
      if (valid) {
        this.showAlert(this.$t('change_password.confirmation').toString(), this.$data.SamclickAlert.WARNING, false).then(() => {
          MyaaffiliateStore.passwordReset(new Payload({ mail: this.state.formData.email, system_tag: 'MYA', request_email: false })).then((response) => {
            this.state.formData.activeSteps = 2;
          }, (error) => {
            if (error.status === 404) {
              this.showAlert(this.$t('change_password.err_not_registered').toString(), this.$data.SamclickAlert.ERROR);
            } else {
              this.showAlert(this.$t('change_password.err_invalid_email').toString(), this.$data.SamclickAlert.ERROR);
            }
          });
        }).catch(() => {
        });
      }
    });
  }

  backToTop() {
    this.state.formData.activeSteps = 1;
    this.state = new PasswordResetState();
    this.$router.push({ name: 'login' });
  }

  /**
 * Computed
 * */
  getcomputedVal() {
    return {};
  }

  /**
 * Lifecycle hooks
 * */
  created() {
  }

  mounted() {
  }

  beforeUpdate() {
  }
}
